import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { EnterValueDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-dialog.component';
import {
    EnterValueInput,
    EnterValueResponse,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-response';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import {
    FilterItem,
    FilterItemType,
} from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { KieneFileService } from '../../../../projects/kiene-core/src/lib/services/files/kiene-file.service';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneUtils } from '../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import {
    ConditionSetting,
    ConditionTableColumn,
    DateTableColumn,
    FunctionTableColumn,
    IfElseTableColumn,
    NumberTableColumn,
    PdfTableColumn,
    TableColumn,
} from '../../components/kiene-table/table-column';
import { TableDescriptor, ToolbarButton } from '../../components/kiene-table/table-descriptor';
import { Condition, Operator, TableOption } from '../../components/kiene-table/table-option';
import { MonthSelectorResult } from '../../components/month-selector/month-selector/month-selector';
import { MonthSelectorComponent } from '../../components/month-selector/month-selector/month-selector.component';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { InvoiceGenerationDialogComponent } from '../../dialogs/invoice-generation-dialog/invoice-generation-dialog.component';
import { Invoice } from './rechnung';
import { RechnungBelegeDialogComponent, StornoResult } from './rechnung-belege-dialog/rechnung-belege-dialog.component';
import { RechnungEmailDialogComponent } from './rechnung-email-dialog/rechnung-email-dialog.component';
import { RechnungGeneration } from './rechnung-generation';
import { RechnungStornoDialogComponent } from './rechnung-storno-dialog/rechnung-storno-dialog.component';

@Component({
    selector: 'kiene-rechnungen',
    templateUrl: './rechnungen.component.html',
    styleUrls: ['./rechnungen.component.scss'],
})
export class RechnungenComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();
    vetvetMandant: boolean;

    constructor(
        public dialog: MatDialog,
        private tableService: KieneTableService,
        private api: KieneBackendApiService,
        private messageService: MessageService,
        private pdfService: PdfViewerDesktopService,
        private http: HttpClient,
        private router: Router,
        private route: ActivatedRoute,
        private localStorageService: LocalStorageService,
        private fileService: KieneFileService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {
        this.localStorageService.setCurrentClientVisible(true);
    }

    ngOnInit() {
        this.vetvetMandant = !!(this.localStorageService.getCurrentMandant()?.mandant_id === 0);

        this.tableDescriptor.headline = 'Rechnungen';
        this.tableDescriptor.uniqueIdentifier = 'Rechnungen';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'rechnung/';
        this.tableDescriptor.route = '/finanzen/rechnungen/';
        this.tableDescriptor.nameOfIdField = 'rechnung_id';
        this.tableDescriptor.searchPlaceholder = 'Rechnungen durchsuchen';
        this.tableDescriptor.createAllowed = false;
        this.tableDescriptor.showDetailsVoid = this.showDetails.bind(this);

        this.tableDescriptor.columns.push(new TableColumn('rechnung_id', 'ID'));
        this.tableDescriptor.columns.push(new TableColumn('rechnung_nr', 'Rechnung Nr.'));
        if (this.vetvetMandant) {
            this.tableDescriptor.columns.push(new TableColumn('benutzer', 'Benutzer'));
        } else {
            this.tableDescriptor.columns.push(new TableColumn('kunde', 'Kunde'));
            this.tableDescriptor.columns.push(new TableColumn('zusatz', 'Zusatz'));
            this.tableDescriptor.columns.push(new TableColumn('gruppe', 'Gruppe'));
        }
        this.tableDescriptor.columns.push(new TableColumn('rechnungsdatum', 'Rechnungsdatum', 'date'));
        this.tableDescriptor.columns.push(new TableColumn('status', 'Status'));
        this.tableDescriptor.columns.push(new TableColumn('status_bezahlung', 'Status Bezahlung'));
        if (this.vetvetMandant) {
            this.tableDescriptor.columns.push(new TableColumn('payment_intent_id', 'Stripe Id'));
        }
        this.tableDescriptor.columns.push(new NumberTableColumn('gesamt_netto', 'Gesamt Netto (Euro)'));
        this.tableDescriptor.columns.push(new NumberTableColumn('gesamt_brutto', 'Gesamt Brutto (Euro)'));

        if (!this.vetvetMandant) {
            const conditionSettingsPrimanota = [
                new ConditionSetting([new Condition('primanota_id', Operator.EXISTIERT, null)], {
                    icon: 'check',
                    color: 'green',
                    tooltip: 'Bereits zur FiBu exportiert',
                }),
            ];
            this.tableDescriptor.columns.push(
                new ConditionTableColumn('primanota_id', 'Primanota', conditionSettingsPrimanota, {
                    sortFields: ['primanota_id'],
                }),
            );

            const conditionSettingsGutschrift = [
                new ConditionSetting([new Condition('kundengutschrift_id', Operator.EXISTIERT, null)], {
                    icon: 'check',
                    color: 'green',
                    tooltip: 'Gutschrift erstellt',
                }),
            ];
            this.tableDescriptor.columns.push(
                new ConditionTableColumn('kundengutschrift_id', 'Gutschrift', conditionSettingsGutschrift, {
                    sortFields: ['kundengutschrift_id'],
                }),
            );
        }

        const conditionSettingsMail = [
            new ConditionSetting([new Condition('mail', Operator.GLEICH, 0)], {
                icon: 'mail',
                color: 'orange',
                tooltip: 'Email in Warteschlange',
            }),
            new ConditionSetting([new Condition('mail', Operator.GROESSER, 0)], {
                icon: 'mark_email_read',
                color: 'green',
                tooltip: 'Email gesendet',
            }),
        ];
        this.tableDescriptor.columns.push(
            new ConditionTableColumn('mail', 'Email', conditionSettingsMail, { sortFields: ['mail'] }),
        );

        this.tableDescriptor.columns.push(new TableColumn('mail_zeitstempel', 'Email Datum', 'date'));

        const conditionSettingsDrucker = [
            new ConditionSetting([new Condition('gedruckt', Operator.GROESSER, 0)], {
                icon: 'printer',
                color: 'green',
                tooltip: 'PDF gedruckt',
            }),
        ];
        this.tableDescriptor.columns.push(
            new ConditionTableColumn('gedruckt', 'Gedruckt', conditionSettingsDrucker, { sortFields: ['gedruckt'] }),
        );

        this.tableDescriptor.columns.push(new TableColumn('gedruckt_zeitstempel', 'Gedruckt Datum', 'date'));

        this.tableDescriptor.columns.push(new PdfTableColumn('pdf_id', 'PDF', this.openPdf.bind(this)));

        this.tableDescriptor.options.push(
            new TableOption(this.einzelnFreigeben.bind(this), 'Rechnung freigeben', 'verified', 2973, {
                conditions: [new Condition('status_id', Operator.IN, [51, 52])],
            }),
        );
        if (!this.vetvetMandant) {
            this.tableDescriptor.options.push(
                new TableOption(this.openDeleteDialog.bind(this), 'Rechnung löschen', 'delete', 2974, {
                    conditions: [new Condition('status_id', Operator.GLEICH, 51)],
                }),
            );
            this.tableDescriptor.options.push(
                new TableOption(
                    this.openRechnungBelegeDialog.bind(this),
                    'Stornierte Rechnung korrigieren',
                    'bug_report',
                    2963,
                    {
                        conditions: [
                            new Condition('status_id', Operator.GLEICH, 55),
                            new Condition('rechnung_id_neu', Operator.EXISTIERT_NICHT, null),
                        ],
                    },
                ),
            );
            this.tableDescriptor.options.push(
                new TableOption(this.openStornoDialog.bind(this), 'Rechnung stornieren', 'clear', 2963, {
                    conditions: [
                        new Condition('status_id', Operator.GROESSER_GLEICH, 53),
                        new Condition('status_id', Operator.KLEINER_GLEICH, 54),
                    ],
                }),
            );
            this.tableDescriptor.options.push(
                new TableOption(this.gutschriftAnzeigen.bind(this), 'Gutschrift anzeigen', 'description', 2945, {
                    conditions: [new Condition('kundengutschrift_id', Operator.EXISTIERT, '')],
                }),
            );
            this.tableDescriptor.options.push(
                new TableOption(
                    this.rechnungNeuAnzeigen.bind(this),
                    'Neue Rechnung anzeigen',
                    'monetization_on',
                    2971,
                    { conditions: [new Condition('rechnung_id_neu', Operator.EXISTIERT, null)] },
                ),
            );
        }
        this.tableDescriptor.options.push(
            new TableOption(this.drucken.bind(this), 'Rechnung drucken', 'printer', 2962, {
                conditions: [new Condition('status_id', Operator.GLEICH, 53)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.setBezahlen.bind(this), 'Rechnung bezahlt', 'euro_symbol', 2963, {
                conditions: [new Condition('status_bezahlung', Operator.GLEICH, 'nicht übertragen')],
            }),
        );

        this.tableDescriptor.expandable = true;
        this.tableDescriptor.expandableFieldName = 'positionen';
        this.tableDescriptor.expandableColumns.push(new DateTableColumn('datum', 'Belegdatum', 'dd.MM.yyyy'));
        this.tableDescriptor.expandableColumns.push(
            new IfElseTableColumn('beleg', 'Beleg', 'abgabebeleg_id', 'abgabebeleg_nr', 'tagebuch_nr'),
        );
        this.tableDescriptor.expandableColumns.push(new TableColumn('artikel', 'Artikel'));
        this.tableDescriptor.expandableColumns.push(new FunctionTableColumn('behandlung', 'Typ', this.getArticleType));
        this.tableDescriptor.expandableColumns.push(new TableColumn('artikelmenge', 'Menge'));
        this.tableDescriptor.expandableColumns.push(new NumberTableColumn('einzelpreis', 'Einzelpreis (€)', '1.2-2'));
        this.tableDescriptor.expandableColumns.push(
            new NumberTableColumn('gesamtpreis', 'Gesamtpreis Netto (€)', '1.2-2'),
        );
        this.tableDescriptor.expandableColumns.push(new NumberTableColumn('mwstsatz', 'MwSt (%)', '1.0-0'));
        this.tableDescriptor.expandableColumns.push(new TableColumn('kommentar', 'Kommentar'));
        if (this.vetvetMandant) {
            this.tableDescriptor.toolbarButtons.push(
                new ToolbarButton(
                    this.generateInvoicesVetvet.bind(this),
                    'monetization_on',
                    2968,
                    'Rechnungen generieren',
                ),
            );
        } else {
            this.tableDescriptor.toolbarButtons.push(
                new ToolbarButton(
                    this.openInvoiceGenerationDialog.bind(this),
                    'monetization_on',
                    2979,
                    'Rechnungen generieren',
                ),
            );
        }
        this.tableDescriptor.toolbarButtons.push(
            new ToolbarButton(this.alleFreigeben.bind(this), 'verified', 2961, 'Alle Rechnungen freigeben'),
        );
        if (!this.vetvetMandant) {
            this.tableDescriptor.toolbarButtons.push(
                new ToolbarButton(
                    this.alleExportieren.bind(this),
                    'picture_as_pdf',
                    2962,
                    'Alle Rechnungen exportieren',
                ),
            );
        }
        this.tableDescriptor.toolbarButtons.push(
            new ToolbarButton(this.mailsSenden.bind(this), 'mail', 2964, 'Alle Rechnungen per Mail an Kunden senden'),
        );
        if (!this.vetvetMandant) {
            this.tableDescriptor.toolbarButtons.push(
                new ToolbarButton(this.generatePrimanota.bind(this), 'account_balance', 2978, 'FiBu CSV generieren'),
            );

            const mandant = this.localStorageService.getCurrentMandant();
            if (mandant.mandant_id == 1) {
                this.tableDescriptor.toolbarButtons.push(
                    new ToolbarButton(this.downloadBrueninghoff.bind(this), 'pets', 2969, 'Brüninghoff CSV erstellen'),
                );
            }
        } else {
            /*this.tableDescriptor.toolbarButtons.push(
                new ToolbarButton(this.sendToStripe.bind(this), 'send', 2966, 'Rechnungen an Stripe senden'),
            );*/
        }

        this.tableDescriptor.permissionCreate = 2973;
        this.tableDescriptor.permissionView = 2971;

        this.tableDescriptor.filterItems.push(
            new FilterItem('Rechnung erstellt', 51, FilterItemType.CHECKBOX, 'status_id'),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Rechnung freigegeben', 52, FilterItemType.CHECKBOX, 'status_id'),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Rechnung PDF erzeugt', 53, FilterItemType.CHECKBOX, 'status_id'),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Rechnung exportiert', 54, FilterItemType.CHECKBOX, 'status_id'),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Rechnung storniert', 55, FilterItemType.CHECKBOX, 'status_id'),
        );

        this.tableDescriptor.initialSortColumn = 'rechnung_id';
        this.tableDescriptor.initialSortDirection = 'desc';
    }

    gutschriftAnzeigen(invoice: Invoice) {
        const input = new PdfViewerDialogInput(
            'kundengutschrift/read_or_mail_pdf.php',
            new HttpParams().set('kundengutschrift_id', invoice?.kundengutschrift_id?.toString()),
            'Gutschrift ' + invoice?.kundengutschrift_id?.toString(),
            { email: { sende_mail: true, kunde_id: invoice?.kunde_id } },
        );
        this.pdfService.openPdfViewer(input);
    }

    public getArticleType(behandlung: number): string {
        return KieneUtils.isApiOne(behandlung) ? 'Behandlung' : 'Abgabe';
    }

    hasPermission(permissionId: number): boolean {
        return this.localStorageService.currentUserHasPermission(permissionId);
    }

    openPdf(invoice: Invoice) {
        const input = new PdfViewerDialogInput(
            'rechnung/read_or_mail_pdf.php',
            new HttpParams().set('rechnung_id', invoice?.rechnung_id?.toString()),
            'Rechnung ' + invoice?.rechnung_nr,
            { email: { sende_mail: true, kunde_id: invoice?.kunde_id } },
        );
        input.isInvoice = true;
        this.pdfService.openPdfViewer(input).subscribe({
            next: () => {
                this.tableService.reload();
            },
        });
    }

    showDetails(invoice: Invoice) {
        if (this.hasPermission(2973)) {
            this.router.navigate([invoice[this.tableDescriptor.nameOfIdField]], { relativeTo: this.route });
        } else {
            this.openPdf(invoice);
        }
    }

    downloadBrueninghoff() {
        const dialog = this.dialog.open(MonthSelectorComponent, { width: '40%', minWidth: '400px' });

        dialog.afterClosed().subscribe((response: MonthSelectorResult) => {
            if (response?.confirmed) {
                const params = new HttpParams()
                    .set('monat', response?.monat?.toString())
                    .set('jahr', response?.jahr?.toString());
                this.fileService.downloadCSV(this.apiBaseUrl + 'rechnung/csv_brueninghoff.php', params);
            }
        });
    }

    rechnungNeuAnzeigen(invoice: Invoice) {
        this.router.navigate([invoice.rechnung_id_neu], { relativeTo: this.route }).then();
    }

    openStornoDialog(invoice: Invoice) {
        this.dialog
            .open(RechnungStornoDialogComponent, { data: { invoice: invoice } })
            .afterClosed()
            .subscribe({
                next: (result: Invoice) => {
                    if (result) {
                        this.messageService.infoMessage('Rechnung wurde storniert!');
                        this.tableService.reload();

                        const params = new HttpParams().set('rechnung_id', invoice?.rechnung_id);
                        this.api.get(this.apiBaseUrl + 'rechnung/read_storno.php', params).subscribe({
                            next: (response: StornoResult) => {
                                if (response?.abgabebelege?.length > 0 || response?.befunde?.length > 0) {
                                    this.openRechnungBelegeDialog(invoice);
                                }
                            },
                        });
                    }
                },
            });
    }

    openRechnungBelegeDialog(invoice: Invoice) {
        this.dialog.open(RechnungBelegeDialogComponent, { width: '80%', data: { invoice: invoice } });
    }

    openDeleteDialog(invoice: Invoice) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '500px',
            data: { title: 'Rechnung wirklich löschen?', text: 'Rechnung wirklich löschen?' },
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                this.tableService.deleteEntity(this.apiBaseUrl + 'rechnung/delete.php', invoice).subscribe(
                    () => {
                        this.messageService.infoMessage('Rechnung wurde erfolgreich gelöscht!');
                        this.tableService.reload();
                    },
                    error => {
                        this.messageService.errorMessage('Rechnung konnte nicht gelöscht werden!', error);
                    },
                );
            }
        });
    }

    /*sendToStripe() {
        const input = new ConfirmDialogInput();
        input.headline = 'Rechnungen an Stripe';
        input.text = 'Sollen alle freigegeben Rechnungen an Stripe gesendet werden?';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (result: ConfirmDialogResult) => {
                    if (result?.confirmed) {
                        this.tableService.post(this.apiBaseUrl + 'stripe/send.php', {}).subscribe({
                            next: () => {
                                this.tableService.reload();
                            },
                            error: err => {
                                this.messageService.errorMessage('Fehler!', err);
                            },
                        });
                    }
                },
            });
    }*/

    generateInvoicesVetvet() {
        const enterValueInput = new EnterValueInput();
        enterValueInput.title = 'Rechnungen VetVet';
        enterValueInput.text = 'Sollen die Rechnungen erzeugt werden?';
        enterValueInput.okButton = 'Rechnungen erzeugen';
        enterValueInput.addInputValue('Zeitraum bis', 'date');

        this.dialog
            .open(EnterValueDialogComponent, { data: enterValueInput })
            .afterClosed()
            .subscribe({
                next: (response: EnterValueResponse) => {
                    if (response.result) {
                        const dat = { datum_bis: response.getValue(0) };
                        this.tableService.post(this.apiBaseUrl + 'rechnung/generieren_vetvet.php', dat).subscribe({
                            next: () => {
                                this.tableService.reload();
                            },
                            error: err => {
                                this.messageService.errorMessage('Fehler!', err);
                            },
                        });
                    }
                },
            });
    }

    openInvoiceGenerationDialog() {
        const dialogRef = this.dialog.open(InvoiceGenerationDialogComponent, { minWidth: '400px' });

        dialogRef.afterClosed().subscribe(data => {
            if (data) {
                const rg = <RechnungGeneration>data;
                this.tableService.post(this.apiBaseUrl + 'rechnung/generieren.php', rg).subscribe(
                    () => {
                        this.messageService.infoMessage('Die Rechnungen wurden erfolgreich generiert!');
                        this.tableService.reload();
                    },
                    error => {
                        this.messageService.errorMessage(
                            'Die Rechnungen konnten nicht generiert werden. Es ist ein Fehler aufgetreten: ',
                            error,
                        );
                    },
                );
            }
        });
    }

    generatePrimanota() {
        this.http.post(this.apiBaseUrl + 'primanota/generieren_rechnungen.php', {}).subscribe(
            () => {
                this.messageService.infoMessage('Die Primanota wurde erfolgreich generiert!');
                this.router.navigate(['../primanota'], { relativeTo: this.route });
            },
            error => {
                this.messageService.errorMessage('Es ist ein Fehler beim Generieren der Primanota aufgetreten!', error);
            },
        );
    }

    alleFreigeben() {
        this.messageService.infoMessage('Rechnungen werden freigegeben, bitte warten!');
        this.tableService.post(this.apiBaseUrl + 'rechnung/freigeben_alle.php', null, null).subscribe(
            () => {
                this.messageService.infoMessage('Rechnungen erfolgreich freigegeben!');
                this.tableService.reload();
            },
            error => {
                this.messageService.errorMessage('Es ist ein Fehler aufgetreten!', error);
            },
        );
    }

    einzelnFreigeben(invoice: Invoice) {
        this.messageService.infoMessage('Rechnung wird freigegeben, bitte warten!');
        this.tableService.post(this.apiBaseUrl + 'rechnung/freigeben_einzeln.php', invoice, null).subscribe(
            () => {
                this.messageService.infoMessage('Rechnung erfolgreich freigegeben!');
                this.tableService.reload();
            },
            error => {
                this.messageService.errorMessage('Rechnung konnte nicht freigegeben werden!', error);
            },
        );
    }

    drucken(r: Invoice) {
        this.http
            .get(this.apiBaseUrl + 'rechnung/exportieren.php', {
                params: new HttpParams().set('rechnung_id', r.rechnung_id.toString()).set('returnpdf', '0'),
            })
            .subscribe({
                next: () => {
                    this.tableService.reload();
                    this.openPdf(r);
                },
                error: err => {
                    this.messageService.errorMessage('Fehler!', err);
                },
            });
    }

    mailsSenden() {
        const dialogRef = this.dialog.open(RechnungEmailDialogComponent);

        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result) {
                    this.messageService.infoMessage('Rechnungen werden im Hintergrund gesendet!');

                    const formData = new FormData();
                    formData.append('datum_von', new Date(result.datum_von).toISOString());
                    formData.append('datum_bis', new Date(result.datum_bis).toISOString());
                    if (result.file) {
                        formData.append('dokument', result.file);
                    }

                    const options = {
                        headers: new HttpHeaders('Phito-Type: fileupload'),
                        observe: 'events',
                        reportProgress: true,
                    };

                    this.api.postFormData(this.apiBaseUrl + 'rechnung/send_mails.php', formData, options).subscribe({
                        next: () => {
                            this.messageService.infoMessage('Alle Rechnungen in Mail Warteschlange hinzugefügt!');
                            this.tableService.reload();
                        },
                        error: err => {
                            this.messageService.errorMessage(
                                'Es ist ein Fehler beim Versenden der Rechnungen aufgetreten!',
                                err,
                            );
                        },
                    });
                }
            },
        });
    }

    alleExportieren() {
        this.messageService.infoMessage('Rechnungen werden exportiert, bitte warten!');
        // TODO: Download Service nutzen
        this.http
            .get(this.apiBaseUrl + 'rechnung/exportieren.php', { responseType: 'blob', observe: 'response' })
            .subscribe(
                response => {
                    if (response) {
                        const pdfBlob = new Blob([response.body], { type: 'application/pdf' });
                        if (pdfBlob.size > 0) {
                            const url = window.URL.createObjectURL(pdfBlob);
                            const a = document.createElement('a');
                            a.style.display = 'none';
                            document.body.appendChild(a);
                            a.href = url;
                            a.download = 'Rechnungen.pdf';
                            a.click();
                            window.URL.revokeObjectURL(url);
                        }
                        this.tableService.reload();
                    }
                },
                error => {
                    this.messageService.errorMessage('Fehler beim Exportieren der Rechnungen!', error);
                },
            );
    }

    private setBezahlen(invoice: Invoice) {
        const input = new ConfirmDialogInput();
        input.headline = 'Rechnung bezahlt';
        input.text = 'Soll die Rechnung als bezahlt markiert werden?';
        input.okButton = 'Ja';
        input.cancelButton = 'Nein';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (result: ConfirmDialogResult) => {
                    if (result?.confirmed) {
                        this.tableService.post(this.apiBaseUrl + 'rechnung/bezahlt.php', invoice, null).subscribe({
                            next: () => {
                                this.messageService.infoMessage('Rechnung wurde als bezahlt markiert!');
                                this.tableService.reload();
                            },
                            error: err => {
                                this.messageService.errorMessage('Fehler!', err);
                            },
                        });
                    }
                },
            });
    }
}
